<template />

<script>
import { nameBrand } from '~/util/defaultInfo'

export default {
  name: 'SeoTemplate',
  props: {
    seoTitle: { type: String, required: true },
    seoDescription: { type: String, required: true },
    ogImgUrl: { type: String, required: false },
    twitterImgUrl: { type: String, required: true },
  },
  head() {
    return {
      title: this.seoTitle,
      meta: this.getMeta(),
    }
  },
  methods: {
    getMeta() {
      const arrAllMeta = [
        {
          hid: 'description',
          name: 'description',
          content: this.seoDescription,
        },
        { hid: 'og:type', property: 'og:type', content: 'article' },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.seoTitle,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.seoDescription,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content:
              this.$config.cloudUrl
              + (this.$i18n.locale === 'ru'
                ? this.$route.path
                : this.$route.path === '/'
                  ? this.$route.path.slice(1)
                  : this.$route.path),
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: nameBrand,
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: this.$i18n.locale === 'ua' ? 'uk_UA' : 'ru_UA',
        },
        { name: 'twitter:card', content: 'summary' },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.seoTitle,
        },
        {
          hid: 'twitter:site',
          name: 'twitter:site',
          content: `@${nameBrand}`,
        },
        {
          hid: 'twitter:creator',
          name: 'twitter:creator',
          content: `@${nameBrand}`,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.seoDescription,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: `${this.$config.baseURL}${this.twitterImgUrl}`,
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content: this.seoTitle,
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content:
              this.$config.cloudUrl
              + (this.$i18n.locale === 'ru'
                ? this.$route.path
                : this.$route.path === '/'
                  ? this.$route.path.slice(1)
                  : this.$route.path),
        },
      ]

      const arrOgImg = [
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.$config.baseURL}${this.ogImgUrl}`,
        },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: `${this.$config.baseURL}${this.ogImgUrl}`,
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.seoTitle,
        },
      ]

      const result = this.ogImgUrl ? [ ...arrAllMeta, ...arrOgImg ] : [ ...arrAllMeta ]
      return result
    },
  },
}
</script>
